// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg viewBox=\"0 0 120 30\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23007bff\"><circle cx=\"15\" cy=\"15\" r=\"15\"><animate attributeName=\"r\" from=\"15\" to=\"15\" begin=\"0s\" dur=\"0.8s\" values=\"15;9;15\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle><circle cx=\"60\" cy=\"15\" r=\"9\"><animate attributeName=\"r\" from=\"9\" to=\"9\" begin=\"0.2s\" dur=\"0.8s\" values=\"9;15;9\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle><circle cx=\"105\" cy=\"15\" r=\"15\"><animate attributeName=\"r\" from=\"15\" to=\"15\" begin=\"0.4s\" dur=\"0.8s\" values=\"15;9;15\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Bulle flottante */
.fcb-bubble-icon {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #007bff;
    color: white;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    animation: pulse 2s infinite;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
    z-index: 9999;
  }
  
  @keyframes pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.08); }
    100% { transform: scale(1); }
  }
  
  /* Wrapper avec transition */
  .fcb-window-wrapper {
    position: fixed;
    bottom: 90px;
    right: 20px;
    z-index: 9998;
    transition: all 0.3s ease-in-out;
    opacity: 0;
    transform: scale(0.9);
    pointer-events: none;
  }
  
  .fcb-window-wrapper.open {
    opacity: 1;
    transform: scale(1);
    pointer-events: auto;
  }
  
  /* Fenêtre principale */
  .fcb-window {
    width: 340px;
    max-height: 500px;
    background: white;
    border-radius: 16px;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
  
  /* Header */
  .fcb-header {
    background-color: #007bff;
    color: white;
    padding: 12px;
    font-weight: bold;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .fcb-close-btn {
    cursor: pointer;
    font-size: 18px;
  }
  
  /* Contenu du chat */
  .fcb-chat {
    padding: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    overflow-y: auto;
  }
  
  /* Bulles de message */
  .fcb-chat-bubble {
    padding: 10px 14px;
    border-radius: 20px;
    max-width: 85%;
    font-size: 14px;
    line-height: 1.4;
    word-wrap: break-word;
    animation: fadeIn 0.3s ease-in;
  }
  
  .fcb-bot {
    align-self: flex-start;
    background: #f1f0f0;
    color: #333;
  }
  
  .fcb-user {
    align-self: flex-end;
    background: #007bff;
    color: white;
  }
  
  /* Animation fade */
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  /* Zone de saisie */
  textarea,
  input[type="email"] {
    width: 100%;
    padding: 8px 10px;
    border-radius: 12px;
    border: 1px solid #ccc;
    resize: none;
    font-size: 14px;
  }
  
  /* Boutons */
  .fcb-btn-group,
  .fcb-btn-row {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  
  .fcb-btn-group button,
  .fcb-btn-row button {
    padding: 8px 12px;
    background: #007bff;
    color: white;
    border: none;
    border-radius: 12px;
    cursor: pointer;
    font-size: 14px;
    transition: background 0.2s;
  }
  
  .fcb-btn-group button:hover,
  .fcb-btn-row button:hover {
    background: #005dc4;
  }
  
  /* Animation "..." de frappe du bot */
  .fcb-chat-bubble.fcb-bot.typing span::after {
    content: '';
    display: inline-block;
    vertical-align: middle;
    margin-left: 5px;
    width: 1em;
    height: 1em;
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center;
    background-size: contain;
    width: 20px;
    height: 20px;
  }
  
  /* Responsive */
  @media (max-width: 768px) {
    .fcb-window {
        margin-bottom: 100px;
        width: 90vw;
        max-height: 80vh;
      }
    
      .fcb-window-wrapper {
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        justify-content: center;
        pointer-events: none;
        z-index: 9998;
        transition: all 0.3s ease-in-out;
        opacity: 0;
      }
      
      .fcb-window-wrapper.open {
        pointer-events: auto;
        opacity: 1;
      }
      
      
  
    .fcb-bubble-icon {
      right: 20px;
      bottom: 20px;
    }
  }
  
  /* Tooltip qui sort de l'icône chat */
.fcb-tooltip {
    position: fixed;
    bottom: 90px;
    right: 90px;
    background-color: #fff;
    color: #333;
    padding: 8px 14px;
    border-radius: 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    font-size: 14px;
    white-space: nowrap;
    opacity: 0;
    animation: tooltipFade 0.4s ease-out forwards;
    z-index: 9999;
    transition: opacity 0.3s ease;
  }
  
  @keyframes tooltipFade {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/composant/feedbackChatbot.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,4BAA4B;IAC5B,0CAA0C;IAC1C,aAAa;EACf;;EAEA;IACE,KAAK,mBAAmB,EAAE;IAC1B,MAAM,sBAAsB,EAAE;IAC9B,OAAO,mBAAmB,EAAE;EAC9B;;EAEA,4BAA4B;EAC5B;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,aAAa;IACb,gCAAgC;IAChC,UAAU;IACV,qBAAqB;IACrB,oBAAoB;EACtB;;EAEA;IACE,UAAU;IACV,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA,uBAAuB;EACvB;IACE,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,yCAAyC;IACzC,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;EAClB;;EAEA,sBAAsB;EACtB;IACE,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;EAChC;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;IAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;EAC7C;;EAEA,mBAAmB;EACnB;;IAEE,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;;EAEA,YAAY;EACZ;;IAEE,aAAa;IACb,eAAe;IACf,QAAQ;EACV;;EAEA;;IAEE,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,2BAA2B;EAC7B;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA,qCAAqC;EACrC;IACE,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;IAChB,UAAU;IACV,WAAW;IACX,oEAA4oB;IAC5oB,wBAAwB;IACxB,WAAW;IACX,YAAY;EACd;;EAEA,eAAe;EACf;IACE;QACI,oBAAoB;QACpB,WAAW;QACX,gBAAgB;MAClB;;MAEA;QACE,eAAe;QACf,SAAS;QACT,OAAO;QACP,WAAW;QACX,aAAa;QACb,uBAAuB;QACvB,oBAAoB;QACpB,aAAa;QACb,gCAAgC;QAChC,UAAU;MACZ;;MAEA;QACE,oBAAoB;QACpB,UAAU;MACZ;;;;IAIF;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,qCAAqC;AACvC;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,0CAA0C;IAC1C,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,6CAA6C;IAC7C,aAAa;IACb,6BAA6B;EAC/B;;EAEA;IACE;MACE,UAAU;MACV,2BAA2B;IAC7B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF","sourcesContent":["/* Bulle flottante */\n.fcb-bubble-icon {\n    position: fixed;\n    bottom: 20px;\n    right: 20px;\n    background-color: #007bff;\n    color: white;\n    width: 60px;\n    height: 60px;\n    border-radius: 50%;\n    font-size: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    animation: pulse 2s infinite;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);\n    z-index: 9999;\n  }\n  \n  @keyframes pulse {\n    0% { transform: scale(1); }\n    50% { transform: scale(1.08); }\n    100% { transform: scale(1); }\n  }\n  \n  /* Wrapper avec transition */\n  .fcb-window-wrapper {\n    position: fixed;\n    bottom: 90px;\n    right: 20px;\n    z-index: 9998;\n    transition: all 0.3s ease-in-out;\n    opacity: 0;\n    transform: scale(0.9);\n    pointer-events: none;\n  }\n  \n  .fcb-window-wrapper.open {\n    opacity: 1;\n    transform: scale(1);\n    pointer-events: auto;\n  }\n  \n  /* Fenêtre principale */\n  .fcb-window {\n    width: 340px;\n    max-height: 500px;\n    background: white;\n    border-radius: 16px;\n    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Header */\n  .fcb-header {\n    background-color: #007bff;\n    color: white;\n    padding: 12px;\n    font-weight: bold;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .fcb-close-btn {\n    cursor: pointer;\n    font-size: 18px;\n  }\n  \n  /* Contenu du chat */\n  .fcb-chat {\n    padding: 12px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    overflow-y: auto;\n  }\n  \n  /* Bulles de message */\n  .fcb-chat-bubble {\n    padding: 10px 14px;\n    border-radius: 20px;\n    max-width: 85%;\n    font-size: 14px;\n    line-height: 1.4;\n    word-wrap: break-word;\n    animation: fadeIn 0.3s ease-in;\n  }\n  \n  .fcb-bot {\n    align-self: flex-start;\n    background: #f1f0f0;\n    color: #333;\n  }\n  \n  .fcb-user {\n    align-self: flex-end;\n    background: #007bff;\n    color: white;\n  }\n  \n  /* Animation fade */\n  @keyframes fadeIn {\n    from { opacity: 0; transform: translateY(10px); }\n    to { opacity: 1; transform: translateY(0); }\n  }\n  \n  /* Zone de saisie */\n  textarea,\n  input[type=\"email\"] {\n    width: 100%;\n    padding: 8px 10px;\n    border-radius: 12px;\n    border: 1px solid #ccc;\n    resize: none;\n    font-size: 14px;\n  }\n  \n  /* Boutons */\n  .fcb-btn-group,\n  .fcb-btn-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n  \n  .fcb-btn-group button,\n  .fcb-btn-row button {\n    padding: 8px 12px;\n    background: #007bff;\n    color: white;\n    border: none;\n    border-radius: 12px;\n    cursor: pointer;\n    font-size: 14px;\n    transition: background 0.2s;\n  }\n  \n  .fcb-btn-group button:hover,\n  .fcb-btn-row button:hover {\n    background: #005dc4;\n  }\n  \n  /* Animation \"...\" de frappe du bot */\n  .fcb-chat-bubble.fcb-bot.typing span::after {\n    content: '';\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 5px;\n    width: 1em;\n    height: 1em;\n    background: url('data:image/svg+xml;utf8,<svg viewBox=\"0 0 120 30\" xmlns=\"http://www.w3.org/2000/svg\" fill=\"%23007bff\"><circle cx=\"15\" cy=\"15\" r=\"15\"><animate attributeName=\"r\" from=\"15\" to=\"15\" begin=\"0s\" dur=\"0.8s\" values=\"15;9;15\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle><circle cx=\"60\" cy=\"15\" r=\"9\"><animate attributeName=\"r\" from=\"9\" to=\"9\" begin=\"0.2s\" dur=\"0.8s\" values=\"9;15;9\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle><circle cx=\"105\" cy=\"15\" r=\"15\"><animate attributeName=\"r\" from=\"15\" to=\"15\" begin=\"0.4s\" dur=\"0.8s\" values=\"15;9;15\" calcMode=\"linear\" repeatCount=\"indefinite\" /></circle></svg>') no-repeat center;\n    background-size: contain;\n    width: 20px;\n    height: 20px;\n  }\n  \n  /* Responsive */\n  @media (max-width: 768px) {\n    .fcb-window {\n        margin-bottom: 100px;\n        width: 90vw;\n        max-height: 80vh;\n      }\n    \n      .fcb-window-wrapper {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        width: 100%;\n        display: flex;\n        justify-content: center;\n        pointer-events: none;\n        z-index: 9998;\n        transition: all 0.3s ease-in-out;\n        opacity: 0;\n      }\n      \n      .fcb-window-wrapper.open {\n        pointer-events: auto;\n        opacity: 1;\n      }\n      \n      \n  \n    .fcb-bubble-icon {\n      right: 20px;\n      bottom: 20px;\n    }\n  }\n  \n  /* Tooltip qui sort de l'icône chat */\n.fcb-tooltip {\n    position: fixed;\n    bottom: 90px;\n    right: 90px;\n    background-color: #fff;\n    color: #333;\n    padding: 8px 14px;\n    border-radius: 20px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    font-size: 14px;\n    white-space: nowrap;\n    opacity: 0;\n    animation: tooltipFade 0.4s ease-out forwards;\n    z-index: 9999;\n    transition: opacity 0.3s ease;\n  }\n  \n  @keyframes tooltipFade {\n    from {\n      opacity: 0;\n      transform: translateY(10px);\n    }\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
